import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { publicAssetUrl } from "@/shared/lib/publicAssetUrl"
import { NavbarAuthArea } from "@/widgets/layout/NavbarAuthArea"
import { CabinetSwitcher } from "./CabinetSwitcher"
import type { CabinetId, RoleCabinetId } from "./cabinetNav"
import type { CabinetCounters } from "./useCabinetCounters"

export const CabinetHeader = ({
  ready,
  current,
  available,
  counters,
  canCreateEvents,
  canModerateEvents,
  isAdmin,
  hasSidebar,
  sidebarOpen,
  onToggleSidebar,
}: {
  ready: boolean
  current: CabinetId | null
  available: RoleCabinetId[]
  counters: CabinetCounters
  canCreateEvents: boolean
  canModerateEvents: boolean
  isAdmin: boolean
  hasSidebar: boolean
  sidebarOpen: boolean
  onToggleSidebar: () => void
}) => {
  const { t } = useTranslation()

  return (
    <header className="cabinet-header fixed top-0 left-0 right-0 z-40 h-14">
      <div className="h-full flex items-center gap-2 sm:gap-3 px-3 sm:px-6">
        {hasSidebar ? (
          <button
            type="button"
            onClick={onToggleSidebar}
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md text-white hover:bg-white/10"
            aria-expanded={sidebarOpen}
            aria-controls="cabinet-sidebar"
            aria-label={sidebarOpen ? t("workspaces.closeSidebar") : t("workspaces.openSidebar")}
          >
            <i className="ri-menu-line text-xl" aria-hidden />
          </button>
        ) : null}
        <Link
          to="/catalog"
          aria-label={t("common.brandFull")}
          className="flex items-center gap-1.5 sm:gap-2 shrink-0 rounded-md px-1.5 py-1 hover:bg-white/10 transition-colors"
        >
          <span className="inline-flex rounded-md bg-white px-1.5 py-0.5">
            <img src={publicAssetUrl("images/rgb-logo.svg")} alt="" className="h-7 w-auto" />
          </span>
          <span className="shrink-0 select-none text-lg leading-none font-light text-white/45" aria-hidden>
            ×
          </span>
          <img
            src={publicAssetUrl("images/partners/aila.png")}
            alt={t("nav.partnerAilaAlt")}
            className="h-5 w-auto max-w-[4.25rem] object-contain object-center"
            width={80}
            height={28}
            decoding="async"
          />
        </Link>
        <span className="h-6 w-px bg-white/40 shrink-0" aria-hidden />
        {ready ? (
          <CabinetSwitcher
            current={current}
            available={available}
            counters={counters}
            canCreateEvents={canCreateEvents}
            canModerateEvents={canModerateEvents}
            isAdmin={isAdmin}
          />
        ) : null}
        <div className="ml-auto shrink-0">
          <NavbarAuthArea headerTone="onAccent" showCabinetLink={false} />
        </div>
      </div>
    </header>
  )
}
